export var FamilyFestComingWithEnum;
(function (FamilyFestComingWithEnum) {
    FamilyFestComingWithEnum[FamilyFestComingWithEnum["Alone"] = 1] = "Alone";
    FamilyFestComingWithEnum[FamilyFestComingWithEnum["Guest"] = 2] = "Guest";
    FamilyFestComingWithEnum[FamilyFestComingWithEnum["Family"] = 3] = "Family";
})(FamilyFestComingWithEnum || (FamilyFestComingWithEnum = {}));
export var FamilyFestTravelModeEnum;
(function (FamilyFestTravelModeEnum) {
    FamilyFestTravelModeEnum[FamilyFestTravelModeEnum["Auto"] = 1] = "Auto";
    FamilyFestTravelModeEnum[FamilyFestTravelModeEnum["Bus"] = 2] = "Bus";
    FamilyFestTravelModeEnum[FamilyFestTravelModeEnum["Plane"] = 3] = "Plane";
    FamilyFestTravelModeEnum[FamilyFestTravelModeEnum["Arranged"] = 4] = "Arranged";
})(FamilyFestTravelModeEnum || (FamilyFestTravelModeEnum = {}));
export var FamilyFestAttendanceStatusEnum;
(function (FamilyFestAttendanceStatusEnum) {
    FamilyFestAttendanceStatusEnum[FamilyFestAttendanceStatusEnum["ComingTo"] = 1] = "ComingTo";
    FamilyFestAttendanceStatusEnum[FamilyFestAttendanceStatusEnum["CantMakeIt"] = 2] = "CantMakeIt";
    FamilyFestAttendanceStatusEnum[FamilyFestAttendanceStatusEnum["NoInterest"] = 3] = "NoInterest";
    FamilyFestAttendanceStatusEnum[FamilyFestAttendanceStatusEnum["Others"] = 4] = "Others";
    FamilyFestAttendanceStatusEnum[FamilyFestAttendanceStatusEnum["NoLongerEmployed"] = 5] = "NoLongerEmployed";
})(FamilyFestAttendanceStatusEnum || (FamilyFestAttendanceStatusEnum = {}));
